module.exports = __webpack_public_path__ + "static/media/commerical-3.1b4329eb.jpg";